import Vue from 'vue'
import store from '@/store'
/**
 * 自定义权限指令
 */
Vue.directive('perms', {
  inserted(el, binding) {
    const perms = store.getters.getUser.perms
    if (perms && !perms.contains(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})

// eslint-disable-next-line no-extend-native
Array.prototype.contains = function (val) {
  return this.indexOf(val) !== -1
}
